﻿import React, { useEffect, useRef, useState } from 'react';
import IconHelper from '@bazooka_se/lf-icons';
import Loader from '../../../UI/Loader';

//state
import { connect } from 'react-redux';
import {fetchCategorizedFAQData} from '../State/actions';


const CategorizedFAQQuestionBlock = ({ categories, fAQQuestions, error, loadFAQData }) => {
    const categoryContainerRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const scrollLeftButtonRef = useRef(null);
    const scrollRightButtonRef = useRef(null);
    const [selectedCategory, setSelectedCategory] = useState('aktuellt');
    const [openItemIndex, setOpenItemIndex] = useState(null);

    useEffect(() => {
        loadFAQData(selectedCategory);
    }, [loadFAQData]);

    useEffect(() => {
        const categoryContainer = categoryContainerRef.current;
        const scrollContainer = scrollContainerRef.current;
        const scrollLeftButton = scrollLeftButtonRef.current;
        const scrollRightButton = scrollRightButtonRef.current;

        const handleScrollLeft = () => handleScroll(scrollContainer, -100);
        const handleScrollRight = () => handleScroll(scrollContainer, 100);

        const updateScrollButtonsVisibility = () => {
            if (scrollContainer.scrollLeft === 0) {
                scrollLeftButton.classList.add('hide')
            } else {
                scrollLeftButton.classList.remove('hide')
            }

            if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
                scrollRightButton.classList.add('hide')
            } else {
                scrollRightButton.classList.remove('hide')
            }
        };

        if (scrollContainer && scrollLeftButton && scrollRightButton) {
            toggleScrollable(categoryContainer, scrollContainer);
            updateScrollButtonsVisibility();

            scrollLeftButton.addEventListener('click', handleScrollLeft);
            scrollRightButton.addEventListener('click', handleScrollRight);
            scrollContainer.addEventListener('scroll', updateScrollButtonsVisibility);

            return () => {
                scrollLeftButton.removeEventListener('click', handleScrollLeft);
                scrollRightButton.removeEventListener('click', handleScrollRight);
                scrollContainer.removeEventListener('scroll', updateScrollButtonsVisibility);
            };
        }
    }, [categories])

    const handleClick = (categoryLogicalName) => {
        setSelectedCategory(categoryLogicalName);
        setOpenItemIndex(null); // Reset open item index to make all items closed when changing category
        loadFAQData(categoryLogicalName);

        if (typeof window.dataLayer !== 'undefined') {
            dataLayer.push({
                'category_name': categoryLogicalName,
                'event': 'FAQ Category button'
            });
        }
    };

    const hasScroll = (scrollContainer) => {
        return scrollContainer.scrollWidth > scrollContainer.clientWidth
    }

    const toggleScrollable = (categoryContainer, scrollContainer) => {
        if (hasScroll(scrollContainer)) {
            categoryContainer.classList.add('visible');
        } else {
            categoryContainer.classList.remove('visible');
        }
    };

    const handleScroll = (scrollContainer, direction) => {
        scrollContainer.scrollBy({
            left: direction,
            behavior: 'smooth'
        });
    };

    const toggleOpen = (index) => {
          setOpenItemIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <section className="faq">
            <div className="section-spacing">
                <div className="block-spacing">
                    <div className="faq__category-container" ref={categoryContainerRef}>
                        <button
                            className="faq__scroll-button faq__scroll-button--left"
                            id="faq__scroll-left"
                            aria-label="scrolla vänster"
                            ref={scrollLeftButtonRef}
                        >
                            <span dangerouslySetInnerHTML={{ __html: IconHelper('angle-left').outerHTML }}></span>
                        </button>
                        <button
                            className="faq__scroll-button faq__scroll-button--right"
                            id="faq__scroll-right"
                            aria-label="scrolla höger"
                            ref={scrollRightButtonRef}
                        >
                            <span dangerouslySetInnerHTML={{ __html: IconHelper('angle-right').outerHTML }}></span>
                        </button>

                        {categories && categories.length > 0 ? (
                            <ul className="faq__scroll-container" ref={scrollContainerRef}>
                                {categories.map((category) => (
                                    <li className={`faq__scroll-item ${selectedCategory === category.logicalName ? 'faq__scroll-item__active' : ''}`} key={category.logicalName}>
                                        <button onClick={() => handleClick(category.logicalName)}>{category.displayName}</button>
                                    </li>
                                ))}
                            </ul>
                        ) : null }              
                    </div>

                    <ul className="faq__holder">
                        {fAQQuestions && fAQQuestions.map((item, index) => (            
                            <li key={index} className={`faq__item ${openItemIndex === index ? 'open' : ''}`}>
                                <button
                                    className="faq__question"
                                    aria-expanded={openItemIndex === index ? 'true' : 'false'}
                                    onClick={() => toggleOpen(index)}
                                >
                                    <span>{item.question}</span>
                                    <span dangerouslySetInnerHTML={{ __html: IconHelper('chev-down').outerHTML }}></span>
                                </button>
                                <div
                                    className="faq__answer"
                                    aria-hidden={openItemIndex !== index}
                                    inert={openItemIndex !== index ? 'true' : undefined}
                                >
                                    <div className="faq__answer__text-wrapper">
                                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />

                                        {item.linkUrl  ? (
                                            <a className="link arrow-link" href={item.linkUrl}>
                                                {item.linkText ? item.linkText : "Läs mer"}
                                                <span
                                                    className="icon"
                                                    dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                                                </span>
                                            </a>
                                        ) : null }
                                    </div>
                                </div>        
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
}

const mapStateToProps = (state) => ({
    categories: state.faqData.categories,
    fAQQuestions: state.faqData.fAQQuestions,
    loading: state.faqData.loading,
    error: state.faqData.error
});

const mapDispatchToProps = (dispatch) => ({
    loadFAQData: (selectedCategory) => dispatch(fetchCategorizedFAQData(selectedCategory))
});

export default connect(mapStateToProps, mapDispatchToProps)(CategorizedFAQQuestionBlock);